/** Copy of the sellerFlex page (Operations), ported from VentaHub. */
export const sellerFlex = {
  title: 'SellerFlex Stock',
  description:
    'Our stock a marketplace also reports as its own (Amazon Seller Flex, Noon). These units come off the marketplace’s stock reading so they are not counted twice.',
  chooseTitle: 'Choose a warehouse',
  chooseHint: 'Counts are kept per warehouse and store. Pick the warehouse, then Get details.',
  empty: 'No counts here',
  emptyHint: 'Upload a count sheet for a store, or change the filters.',
  filters: {
    warehouse: 'Warehouse',
    choose: 'Choose…',
    store: 'Store',
    text: 'SKU code or name',
  },
  columns: {
    store: 'Store',
    sku: 'SKU',
    quantity: 'Units',
    asOf: 'Counted on',
    age: 'Age',
    actions: 'Actions',
  },
  age_one: '{{count}} day',
  age_other: '{{count}} days',
  today: 'Today',
  stale: 'Over a week old',
  veryStale: 'Over two weeks old',
  summary: {
    rows: 'Counts',
    units: 'Units taken off',
    newest: 'Newest count',
    oldest: 'Oldest count',
  },
  actions: {
    upload: 'Upload counts',
    download: 'Download register',
    delete: 'Delete',
    deleteOne: 'Delete the count for {{code}} at {{store}}',
  },
  upload: {
    title: 'Upload a SellerFlex count',
    hint: 'The sheet replaces every current count for the store and warehouse you choose; a SKU left off it no longer has a count. It goes for approval, and the counts change once it is accepted.',
    step: 'Where it was counted',
    stepHint: 'The warehouse, the store whose stock sits there, and the day of the count.',
    store: 'Store',
    chooseStore: 'Choose a store',
    chooseWarehouseFirst: 'Choose a warehouse first',
    noStores: 'No store is served from this warehouse.',
    asOf: 'Counted on',
    asOfHint: 'Leave empty for today.',
  },
  delete: {
    title: 'Delete the count for {{code}}?',
    description:
      'Its {{count}} units stop coming off {{store}}’s marketplace stock. The next upload for this store sets it again.',
    done: 'Count for {{code}} deleted.',
  },
} as const
